import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useAppSelector } from '../../../../reducer/hooks';
import { selectIsMobileView } from '../../../../reducer/mediaSlice';
import { InputAdornment, TextField, useTheme } from '@mui/material';

interface IProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label: string;
  isValid?: boolean;
}

const PasswordField: React.FC<IProps> = (props) => {
  const [inputType, setInputType] = useState('password');
  const isMobile = useAppSelector(selectIsMobileView);

  return (
    <div
      className="login-field"
      style={{
        width: '100%',
        display: 'flex',
        alignItems: isMobile ? '' : 'center',
        flexDirection: isMobile ? 'column' : 'row',
        margin: '1rem 0',
      }}
    >
      <label
        style={{
          width: '100%',
          flex: 2,
        }}
      >
        {props.label}
      </label>
      <TextField
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          fontSize: '0.8rem',
          outline: 'none',
          flex: 3,
        }}
        type={inputType}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" style={{ cursor: 'pointer' }}>
              {inputType === 'password' ? (
                <VisibilityOffIcon onClick={() => setInputType('text')} />
              ) : (
                <VisibilityIcon onClick={() => setInputType('password')} />
              )}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default PasswordField;
